module.exports = __webpack_public_path__ + "img/die-presse.35e27d95.svg";